import { combine } from '@core/utils/stringUtils';

import type { IContentTreeProps } from './interface';

export function buildContentTree(contents: string[]): IContentTreeProps[] {
  const levels: Record<string, IContentTreeProps> = {};

  return contents.reduce<IContentTreeProps[]>((result, content, index) => {
    const level = (content.match(/^#+ /g) || [])[0]?.trim();

    if (!level) {
      return result;
    }

    const dict = {
      line: index + 1,
      level: level.length,
      text: content.replace(`${level} `, ''),
    };

    levels[level] = dict;
    result.push(dict);

    return result;
  }, []);
}

export function buildHeadingId({
  line,
  text,
  level,
}: IContentTreeProps): string {
  return combine(
    {
      joinWith: '-',
    },
    level.toString(),
    text,
    line.toString(),
  );
}
